import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-web-shared-ui-lib-compare-button',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './lib-compare-button.component.html',
  styleUrl: './lib-compare-button.component.scss',
})
export class LibCompareButtonComponent {
  @Input({ required: true }) set countCompare(count: number) {
    this.qtyCompare.set(count);
  }
  @Input() set class(classText: string) {
    this.themeClass.set(classText);
  }
  @Output() OnClickCompare = new EventEmitter();

  qtyCompare = signal<number>(0);
  themeClass = signal<string>('');

  handleClickCompare() {
    this.OnClickCompare.emit('');
  }
}
